export const VerificationStatus = {
  WAITING: "waiting",
  ACCEPTED: "accepted",
  REVIEW: "review",
  REJECTED: "rejected",
};
